import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';

export const Title = styled.h1`
    color: ${cssVars.fg_gray1_white};
    margin: 0;
    ${Text.Full.heading2}
`;

export const Subtitle = styled.h3`
    color: ${cssVars.fg_gray2_gray3};
    margin: 10px 0 40px;
    ${Text.Full.large.medium}
`;

export const ProductLink = styled.a`
    display: block;
    width: fit-content;
    background-color: ${cssVars.bg_ash_dark3};
    padding: 8px 32px 10px;
    border-radius: ${radius.large};
    ${Text.Full.large.semibold}
    color: ${Palette.state.info};
    margin-bottom: 20px;
`;
